import { useCallback, useEffect, useState } from 'react';
const STORAGE_KEY = 'dashboard_theme';
/** Dashboard-scoped dark/light theme. Persists to localStorage; light is default. */
export default function useDashTheme() {
    const [theme, setTheme] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved === 'light' || saved === 'dark')
                return saved;
        }
        catch (_a) {
            /* storage unavailable — fall through to default */
        }
        return 'light';
    });
    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        }
        catch (_a) {
            /* storage unavailable — theme just won't persist */
        }
        // Keep every useDashTheme instance on the page in sync (shell + top bar).
        window.dispatchEvent(new CustomEvent('dash-theme-change', { detail: theme }));
    }, [theme]);
    useEffect(() => {
        const onChange = (e) => {
            const next = e.detail;
            if (next === 'light' || next === 'dark')
                setTheme(next);
        };
        window.addEventListener('dash-theme-change', onChange);
        return () => window.removeEventListener('dash-theme-change', onChange);
    }, []);
    const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);
    return [theme, toggle];
}
